import { APP_INITIALIZER, inject } from '@angular/core';
import { ABP, RoutesService } from '@abp/ng.core';
import { BOOKING_REQUEST_BASE_ROUTES } from './booking-request-base.routes';

export const BOOKING_REQUESTS_BOOKING_REQUEST_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);

  return () => {
    const routes: ABP.Route[] = [...BOOKING_REQUEST_BASE_ROUTES];
    routesService.add(routes);
  };
}
